import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { useOutletContext } from 'react-router-dom'
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import { useCallback, useEffect, useState } from 'react';
import AddOffer from '../../../components/AddOffer';
import { updateStore } from '../../../utils/database';
import Helper from '../../../components/Helper';
import Divider from '@mui/material/Divider';
import SaveBanner from '../../../components/SaveBanner'
import Schedule from '../../../components/NewSchedule';
import Typography from '@mui/material/Typography';
import { USER_PLANS } from '../../../utils/structures';
import { SCHEDULE_BASE } from '../../../utils/dates';

export default function MenuData() {
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()
    const [storeModified, setStoreModified] = useState(false);

    const [offers, setOffers] = useState([]);

    const [msgSchedule, setMsgSchedule] = useState(SCHEDULE_BASE);
    const [msgToClients, setMsgToClients] = useState("");

    const [modifyOptionsPrice, setModifyOptionsPrice] = useState(true)
    const [priceChange, setPriceChange] = useState(0);

    useEffect(() => {
        if (userData && userMenu) {

            if ((offers !== userMenu.offers && userMenu.offers !== undefined)
                || (offers.length >= 1 && userMenu.offers === undefined)
                || msgToClients !== userMenu.message.msg
                || msgSchedule !== userMenu.message.schedule
                || (priceChange !== '' && priceChange !== 0)
            ) {
                setStoreModified(true)
                setPreventNavigation(true)
            } else {
                setStoreModified(false)
                setPreventNavigation(false)
            }
        }
    }, [userData, userMenu, offers, msgToClients, msgSchedule, priceChange, setPreventNavigation])

    useEffect(() => {

        if (userMenu) {
            if (userMenu.offers) { setOffers(userMenu.offers) }
            if (userMenu.message.schedule) { setMsgSchedule(userMenu.message.schedule) }
            if (userMenu.message.msg) { setMsgToClients(userMenu.message.msg) }
        }

    }, [userMenu])

    const updateOfferInProducts = useCallback((prevProducts, offers) => {
        let products = [...prevProducts]

        // Elimino todas las offers anteriores de los productos
        for (let i = 0; i < products.length; i++) {
            products[i][1].offer = []
        }

        for (let i = 0; i < offers.length; i++) {

            if (offers[i].products) {

                for (let j = 0; j < offers[i].products.length; j++) {

                    for (let k = 0; k < products.length; k++) {

                        if (products[k][0] === offers[i].products[j]) {

                            products[k][1].offer = offers[i].id
                            break
                        }
                    }
                }
            }
        }

        return Object.fromEntries(products)
    }, [])

    const onOfferUpdate = useCallback(newOffers => {
        let newValues = {}
        newValues.products = updateOfferInProducts(Object.entries(userMenu.products), newOffers)
        newValues.offers = newOffers

        updateStore(userAuth, userData.menuid, newValues)
        // get last values from DB
        updateUserMenu()
        setPreventNavigation(false)
        setStoreModified(false)
    }, [userMenu, userAuth, userData, updateUserMenu, updateOfferInProducts, setPreventNavigation])

    const handleClose = useCallback(() => {
        setStoreModified(false)
        setPreventNavigation(false)
        setPriceChange(0)
    }, [setPreventNavigation])

    const updatePrices = useCallback(products => {
        const normalizedPriceChange = priceChange < -100 ? -100 : priceChange
        let aux = [...products]

        for (let i = 0; i < aux.length; i++) {

            const itemPrice = parseFloat(aux[i][1].price)
            const newItemPrice = (itemPrice + itemPrice * (normalizedPriceChange / 100)).toFixed(2)

            aux[i][1].price = newItemPrice <= 0 ? itemPrice : newItemPrice

            if (modifyOptionsPrice && aux[i][1].options) {
                for (let j = 0; j < aux[i][1].options.length; j++) {

                    if (aux[i][1].options[j].subOptions) {
                        for (let k = 0; k < aux[i][1].options[j].subOptions.length; k++) {

                            const subOptionPrice = parseFloat(aux[i][1].options[j].subOptions[k].price)
                            const newSubOptionPrice = (subOptionPrice + subOptionPrice * (normalizedPriceChange / 100)).toFixed(2)

                            aux[i][1].options[j].subOptions[k].price = newSubOptionPrice <= 0 ? subOptionPrice : newSubOptionPrice
                        }
                    }
                }
            }
        }

        return aux
    }, [priceChange, modifyOptionsPrice])

    const onUpdate = () => {
        let newValues = {}

        if (priceChange !== 0 && priceChange !== "-") {
            newValues.products = Object.fromEntries(updatePrices(Object.entries(userMenu.products)))
        }

        if (!userMenu.message) {
            newValues.message = { msg: msgToClients, schedule: msgSchedule }

        } else if (msgToClients !== userMenu.message.msg || msgSchedule !== userMenu.message.schedule) {
            newValues.message = { msg: msgToClients, schedule: msgSchedule }
        }

        // update new values in the DB
        updateStore(userAuth, userData.menuid, newValues)
        // get last values from DB
        updateUserMenu()
        handleClose()
    }

    return (!userMenu ? null :
        <>

            <Typography variant='h4' sx={{ m: 2 }}>
                Mensaje para los clientes
                <Helper text='Este mensaje se mostrará a todos los clientes cuando visiten tu menú, solo los dias y horarios que indiques' />
            </Typography >

            {userMenu.plan.type === USER_PLANS.free ?
                <Typography variant='h6'>Esta funcion solo esta disponible para el plan PRO. Consiguelo para mostrar mensajes personalizados a tus clientes</Typography> :
                <>
                    <TextField
                        value={msgToClients}
                        onChange={e => setMsgToClients(e.target.value)}
                        fullWidth
                        helperText={`Ejemplo: "Jueves de after! 2x1 en cerveza tirada"`}
                    />

                    <Typography variant='h5' sx={{ m: 2 }}>
                        Horario en el que se verá el mensaje
                    </Typography>

                    <Schedule
                        schedule={msgSchedule}
                        setSchedule={setMsgSchedule}
                    />
                </>}

            <Divider sx={{ m: 2 }} />

            <Typography variant='h4' sx={{ m: 2 }}>
                Modificar Precios Globalmente
                <Helper text={`Ingresa un numero positivo para un aumento de precios global ( 5% ) o un numero negativo para un descuento en todos tus productos ( -5% )`} />
            </Typography >

            {userMenu.plan.type === USER_PLANS.free ?
                <Typography variant='h6'>Esta funcion solo esta disponible para el plan PRO. Consiguelo para poder modificar tus precios globalmente</Typography> :
                <>
                    <FormControlLabel
                        sx={{ m: 1 }}
                        control={<Checkbox
                            checked={modifyOptionsPrice}
                            onChange={e => setModifyOptionsPrice(e.target.checked)}
                        />
                        }
                        label="También modificar los precios de los extras de los productos" />

                    <Stack direction='row' gap='15px' flexWrap='wrap'>

                        <TextField
                            label="Cambio de precios"
                            id="outlined-start-adornment"
                            sx={{ m: 2 }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            value={priceChange}
                            onChange={e => {
                                const inputVal = e.target.value.replace(',', '.');
                                const regex = /^-?(\d*)([,.]\d{0,2})?$/;

                                if (regex.test(inputVal)) {
                                    if (inputVal.length > 1) {
                                        if (inputVal > -100) {
                                            setPriceChange(inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal)
                                        }

                                    } else {
                                        setPriceChange(inputVal.at(0) === '0' && inputVal.length > 0 ? inputVal.slice(1,) : inputVal)
                                    }
                                }
                            }}
                        />

                        <Stack>
                            <Typography sx={{ m: 1 }} variant='h6'>
                                {priceChange === 0 || priceChange === '' || priceChange === '-' ? '' :
                                    `TODOS tus precios ${priceChange > 0 ? 'aumentarán en un ' + priceChange : 'bajarán en un ' + priceChange.slice(1,)}% al guardar los cambios`}
                            </Typography>

                            <Typography sx={{ m: 1 }} variant='p'>
                                {priceChange === 0 || priceChange === '' || priceChange === '-' ? '' :
                                    `Ejemplo: Un producto que actualmente cuesta $100 pasará a valer $${100 + parseFloat(priceChange)}`}
                            </Typography>
                        </Stack>

                    </Stack>
                </>}

            <Divider sx={{ m: 2 }} />

            <Typography variant='h4' sx={{ m: 2 }}>
                Promociones y descuentos
                <Helper text='Crea diferentes promociones que se aplican automaticamente a determinados productos según el dia y hora de la semana' />
            </Typography>

            <Typography sx={{ m: 2 }}>
                Para cada promoción que crees puedes elegir a que productos se aplicará y en que momentos de la semana.
                Ejemplo: 15% de descuento en cerveza tirada y que se aplique solo los jueves de 18:00 a 21:00.
            </Typography>

            {userMenu.plan.type === USER_PLANS.free ?
                <Typography variant='h6'>Esta funcion solo esta disponible para el plan PRO. Consiguelo para crear promociones para tus clientes</Typography> :
                <>
                    <AddOffer
                        offers={offers}
                        onUpdate={onOfferUpdate}
                        setOffers={setOffers}
                        products={userMenu.products ? Object.entries(userMenu.products) : null}
                    />

                    <List>
                        {offers.map(offer => {
                            return (
                                <div key={offer.id}>
                                    <AddOffer
                                        offer={offer}
                                        offers={offers}
                                        onUpdate={onOfferUpdate}
                                        setOffers={setOffers}
                                        products={userMenu.products ? Object.entries(userMenu.products) : null}
                                    />
                                </div>
                            )
                        })}
                    </List>
                </>}

            <SaveBanner
                setPreventNavigation={setPreventNavigation}
                storeModified={storeModified}
                onUpdate={() => onUpdate()}
            />
        </>
    )
}
